var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('v-img',{attrs:{"src":require('../assets/images/spinner.svg'),"contain":"","height":"100px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }